/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Ferieneinarbeiten1Inputs */



/**

* @param {_Field_Ferieneinarbeiten1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_ferieneinarbeiten1 = /** @type {((inputs?: _Field_Ferieneinarbeiten1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Ferieneinarbeiten1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Ferien einarbeiten")
});
export { _field_ferieneinarbeiten1 as "_field_ferienEinarbeiten" }